export default [
  '8chan',
  'abortion',
  'abuse at msu',
  'abusive gratification',
  'abusive users',
  'accident',
  'accidental',
  'accuse',
  'accused',
  'accuser',
  'accuses',
  'acid',
  'act of evil',
  'active gunman',
  'active shooter',
  'active shooter in las vegas',
  'active shooter in las vegas nevada',
  'active shooter las vegas',
  'active shooter mandalay bay las vegas',
  'active shooter vegas',
  'active shooters las vegas',
  'active shooting las vegas',
  'adolf hitler',
  'agressor',
  'air pollution',
  'ak 15',
  'ak 47',
  'akayed ullah',
  'al anon',
  'al iacobelli',
  'al noor',
  'al qaeda',
  'al shabaab',
  'alanon',
  'alex da silva',
  'alex jones',
  'allison mack',
  'alt right',
  'alton sterling',
  'alton sterling death',
  'altright',
  'american mass shooting',
  'american rifleman',
  'amtrak crash',
  'amtrak dangling',
  'amtrak derail',
  'amtrak fatalities',
  'amtrak injuries',
  'anal',
  'angry dragon',
  'annabelle pomeroy',
  'annapolis maryland shooting',
  'annapolis shoot',
  'annapolis shooting',
  'anne frank',
  'anthony rapp',
  'anthony weiner',
  'anti immigrant',
  'anti israel sentiment',
  'anti semitic',
  'anti semitism',
  'antisemitic',
  'antisemitism',
  'anton yelchin',
  'anus',
  'aphrodisiac',
  'arabian goggles',
  'ariana grande blast',
  'ariana grande bombing',
  'ariana grande explosion',
  'ariana grande fatalities',
  'ariana grande manchester',
  'assasin',
  'assassin',
  'assault',
  'assault ban',
  'assault fire',
  'assault machine',
  'assault rifle',
  'assault rifle ban',
  'assault rifle case',
  'asscrack',
  'asshat',
  'asshole',
  'astor shoot',
  'athens fire',
  'atm fees',
  'attack',
  'attack jews',
  'attack victims',
  'auschwitz',
  'austin bomb',
  'austin explosion',
  'austin package',
  'auto accident',
  'automatic ban',
  'ballsack',
  'banking crisis',
  'bankruptcy',
  'bar shooting',
  'barcelona attack',
  'barcelona hostage',
  'barcelona spain van',
  'barcelona terror',
  'barcelona terror attack',
  'bastard',
  'bastards',
  'bastille attack',
  'bastille gunfire',
  'bastille truck',
  'battlefield',
  'beaner',
  'beer cock',
  'benton shoot',
  'bill cosby',
  'bill o reilly',
  "bill o'reilly",
  'bill oreilly',
  'bitch',
  'bitches',
  'bitching',
  'bitchy',
  'black hat',
  'black monday',
  'blackhat',
  'bleeding',
  'blitzed',
  'blood',
  'bloody',
  'blowjob',
  'blumpkin',
  'blunts',
  'bob bashara',
  'boeing 737 crashes',
  'bollocks',
  'bomb',
  'bomb bus',
  'bomb nyc',
  'bomb port authority',
  'bomb times square',
  'bomber',
  'bombing',
  'bombings',
  'bombs',
  'bondage',
  'boned',
  'boner',
  'bong',
  'boob',
  'borderline bar',
  'boyfriend shoots girlfriend',
  'brake defect',
  'brake defects',
  'breast',
  'breitbart',
  'brietbart',
  'brit hume',
  'brooks',
  'broward',
  'broward schools',
  'bullets',
  'bullied',
  'bullshit',
  'bully',
  'bullying',
  'burning odor',
  'burning smell',
  'busty',
  'buttcrack',
  'buttfucker',
  'buttplug',
  'cajun dip stick',
  'california bar shooting',
  'california shoot',
  'california shooting',
  'california shot',
  'call girl',
  'cameltoe',
  'cancer breakfast',
  'cancer cereal',
  'cannabis',
  'cannibal',
  'capital gazette shooting',
  'car accident',
  'car bomb',
  'car combustion',
  'car crash',
  'car explosion',
  'car theft',
  'carlson',
  'casualties',
  'cesar sayoc',
  'chapter seven',
  'charlottesville',
  'charlottesville protests',
  'cheat',
  'cheated',
  'chemical attack',
  'chemical breakfast',
  'chemical cereal',
  'chemical weapons',
  'child abuse',
  'child abuser',
  'child endangerment',
  'child exploitation',
  'child molester',
  'child predators',
  'child sex abuse',
  'child sex abuser',
  'child sex abusers',
  'child shoot',
  'child shot',
  'children shot',
  'china trade war',
  'chinc',
  'chink',
  'choad',
  'chocolate cha cha',
  'chode',
  'christchurch',
  'christopher cantwell',
  'church shoot',
  'church shooting',
  'church shot',
  'cild abusers',
  'circus seal',
  'class action',
  'cleveland steamer',
  'clinton bomb',
  'clinton package',
  'clit',
  'clitorus',
  'cnn bomb',
  'cnn package',
  'co conspirators',
  'cocaine',
  'cock',
  'codiene',
  'collision',
  'combat 18',
  'concentration camp',
  'concert terror attack',
  'confederate',
  'confederate flag',
  'confederate general',
  'confederate memorial',
  'confederate monuments',
  'confederate statue',
  'connor betts',
  'conspiracy',
  'conspirators',
  'consumer complaint',
  'content exploitative',
  'convicted',
  'cooch',
  'cooper square shoot',
  'cooter',
  'cpd commander shot',
  'crack cocaine',
  'crackpipe',
  'crackz',
  'cramped',
  'crash',
  'crash injuries',
  'crash test',
  'crash toronto',
  'crime',
  'critical condition',
  'cruise control defect',
  'cruise control issue',
  'cruise control stuck',
  'crystal meth',
  'cuban airplane crashes',
  'cum',
  'cunt',
  'cyber bully',
  'dago',
  'daily caller',
  'dallas sniper',
  'damn',
  'dangerous',
  'daughters of the confederacy',
  'david katz',
  'dayton ohio mass shooting',
  'dayton ohio massacre',
  'dayton ohio shooting',
  'dead',
  'dead astor',
  'dead cooper square',
  'dead dog',
  'dead east village',
  'deadliest mass shooting',
  'deadly crash',
  'deadly shoot',
  'death',
  'death toll',
  'death wish',
  'deaths',
  'defected brakes',
  'deggo',
  'derrick brooks',
  'deviantart',
  'devin kelley',
  'devin kelley church',
  'devin kelley gun',
  'devin kelley killer',
  'devin kelley murderer',
  'devin kelley shooter',
  'devin kelley texas',
  'devin patrick kelley',
  'dick',
  'dick head',
  'dickhead',
  'dickslap',
  'dickweed',
  'died',
  'dies',
  'dieselgate',
  'dildo',
  'dilf',
  'dimitri pagourtzis',
  'dimitrios pagourtzis',
  'disappear',
  'disappeared',
  'disappearing',
  'disappears',
  'disaster',
  'discharged',
  'doctor barto',
  'dog in a bathtub',
  'domestic terrorism',
  'dominatric',
  'dominatrics',
  'donald trumps missile attack',
  'doral golf club shooter',
  'douche',
  'douchebag',
  'downers',
  'dr barto',
  'dr. barto',
  'dred scott',
  'driving drunk',
  'driving intoxicated',
  'driving under the influence',
  'driving while inebriated',
  'driving while intoxicated',
  'drug dealer',
  'drugged',
  'druggie',
  'drunk',
  'drunk driver',
  'drunk driving',
  'dui',
  'dumb ass',
  'dumbass',
  'dumbshit',
  'dwi',
  'dying',
  'dyke',
  'east village shoot',
  'easter sunday suicide bombings',
  'eat out',
  'economic crisis',
  'ecstacy',
  'ejaculate',
  'el paso mass',
  'el paso massacre',
  'el paso shooting',
  'el perro muerto',
  'elementary shoot',
  'elementary shot',
  'engine stall',
  'engine stalls',
  'epa',
  'epsteins',
  'erection',
  'erotic',
  'erotica',
  'estranged',
  'evacuation',
  'exploited children',
  'explosion',
  'explosion bus',
  'explosion london',
  'explosion nyc',
  'explosion parsons',
  'explosion port authority',
  'explosion subway',
  'explosion times square',
  'explosion tube',
  'explosions',
  'explosive device',
  'extremist',
  'facefuck',
  'fag',
  'faggit',
  'faggot',
  'fagtard',
  'fannie mae',
  'fatal accident',
  'fbi investigation',
  'fellatio',
  'fetish',
  'financial collapse',
  'financial crisis',
  'five dead',
  'flip',
  'flood',
  'flooding',
  'florida massacre',
  'florida school shooter',
  'florida shoot',
  'florida shooting',
  'foreclosure',
  'france attack',
  'france dead',
  'france injured',
  'france truck',
  'fraud',
  'freddie mac',
  'french attack',
  'front crash',
  'fuck',
  'fucked',
  'fuckface',
  'fucking',
  'fuckstick',
  'fumilingus',
  'funbags',
  'gand land',
  'gang land',
  'gangbang',
  'gangland',
  'gary glitter',
  'gazette shoot',
  'general lee',
  'general robert e. lee',
  'genocide',
  'get lit',
  'ghislane maxwell',
  'gilbert health',
  'gilbert recovering',
  'gilbert recovery',
  'gilbert released',
  'gilbert stroke',
  'global warming',
  'glyphosate',
  'great mills incident',
  'great mills shoot',
  'greece fire',
  'greece wildfire',
  'greek wilffire',
  'greg gianforcaro',
  'gun',
  'gun control',
  'gun man',
  'gun shot',
  'gun violence',
  'gunman',
  'gunman at trump doral',
  'gunman truck',
  'guns',
  'gunshot',
  'hack',
  'hacked',
  'hacker',
  'hackers',
  'hacking',
  'hacks',
  'halfstaff',
  'handjob',
  'hang',
  'hanged',
  'harlot',
  'harvest 91 las vegas 2017',
  'harvest 91 shooting',
  'harvest festival shooting',
  'harvey weinstein',
  'harvey weinstein scandal',
  'harvey weinstein sex scandal',
  'harvey weinstein sexual harassment',
  'havana plane crash',
  'hazard',
  'heather heyer',
  'henry farrell',
  'heroin',
  'hershey highway',
  'hezbollah',
  'high school shooting',
  'hijack',
  'hijacker',
  'hijacking',
  'himmler',
  'hitler',
  'hoax',
  'hoe',
  'hoes',
  'hog baying',
  'hog dog rodeo',
  'hollywood assault',
  'hollywood rape',
  'homicide',
  'homo',
  'hooker',
  'hooters',
  'horny',
  'horrific attack',
  'hospital',
  'hospitalized',
  'hot carl',
  'hot karl',
  'hotbox',
  'hump',
  'humped',
  'hung',
  'hurricane florence',
  'ian david long',
  'ian long',
  'ian watkins',
  'illegal payment',
  'illegal payments',
  'impair',
  'impaired',
  'impound',
  'in patient',
  'inadvertent deployment',
  'indicted',
  'information recall vehicle',
  'infowars',
  'injury',
  'intensive rehab',
  'international terror',
  'intoxicate',
  'intoxicated',
  'intoxicated driving',
  'isis',
  'islamic state fighters',
  'islamist militant group',
  'islamist radicals',
  'jack barto',
  'jack off',
  'jackass',
  'jacksonville shoot',
  'jake owen concert shooting',
  'james alex fields',
  'jammiyathul millathu ibrahim',
  'jared fogle',
  'jarrod ramos',
  'jason aldean concert shooting',
  'jason aldean shooting',
  'jason aldean vegas',
  'jason castillo',
  'jason kessler',
  'jeanine pirro',
  'jeff anderson & associates',
  'jeffrey epstein',
  'jeffrey jones',
  'jerk off',
  'jerome durden',
  'jerry sandusky',
  'jesse watters',
  'jihadi',
  'jihadist',
  'jimmy savile',
  'jizz',
  'jizzrack',
  'johan de nysschen',
  'johnnie barto',
  'johnny barto',
  'jonathan oddi',
  'josh duggar',
  'juan lopez',
  'judge jeanine',
  'justice department',
  'justice with judge jeanine',
  'karen bitar',
  'kathy griffin',
  'kavanaugh',
  'kentucky school',
  'kentucky shoot',
  'ketamine',
  'kevin space comes out',
  'kevin space fired',
  'kevin spacey',
  'kevin spacey all the money in the world',
  'kevin spacey allegation',
  'kevin spacey fourteen',
  'kevin spacey gay',
  'kevin spacey house of cards',
  'kevin spacey molestation',
  'kevin spacey molesting',
  'kevin spacey party',
  'kevin spacey rape',
  'kevin spacey sexual assault',
  'kevin spacey treatment',
  'kidnap',
  'kidnapped',
  'kidnapping',
  'kill',
  'kill shot',
  'killed',
  'killer',
  'kineta fire',
  'king center',
  'kinky',
  'kkk',
  'knife',
  'knockers',
  'koepp',
  'kunt',
  'kush',
  'kyke',
  'laa vegas shooting',
  'labia',
  'laid off',
  'larry nassar',
  'las ramblas attack',
  'las ramblas terror attack',
  'las vegas active shooter today',
  'las vegas attack',
  'las vegas attacks',
  'las vegas concert shooting',
  'las vegas gunman',
  'las vegas mandalay bay shooter',
  'las vegas massacre',
  'las vegas music festival shooting',
  'las vegas nevada news',
  'las vegas news',
  'las vegas news mandalay bay',
  'las vegas route 91 shooting',
  'las vegas shooter',
  'las vegas shooters',
  'las vegas shooting',
  'las vegas shooting live',
  'las vegas shooting mandalay',
  'las vegas shooting now',
  'las vegas shooting october 1 2017',
  'las vegas shooting october 2017',
  'las vegas shooting suspect',
  'las vegas shooting today',
  'las vegas shooting tonight',
  'las vegas shooting twitter',
  'las vegas shooting video',
  'las vegas shooting video footage',
  'las vegas shootings',
  'las vegas strip',
  'las vegas terror attack',
  'las vegas terrorist',
  'las vegas terrorist attack',
  'las vegas victims',
  'late term abortion',
  'laura ingraham',
  'lawsuit',
  'lay off',
  'lay offs',
  'layoff',
  'layoffs',
  'lemon',
  'linwood',
  'logan paul',
  'london attack',
  'london incident',
  'london shooting',
  'london westminster shooting',
  'lordstown ohio',
  'lou anna simon',
  'lou dobbs',
  'lsd',
  'lv shooting',
  'lynch',
  'lynched',
  'machelle hackney',
  'machine gun',
  'madden shoot',
  'magic mushrooms',
  'magicstick',
  'manchester arena',
  'manchester attack',
  'manchester concert attack',
  'manchester death',
  'manchester explosion',
  'manchester explosions',
  'manchester victims',
  'mandalay bay',
  'mandalay bay casino shooting',
  'mandalay bay concert shooting',
  'mandalay bay gunman',
  'mandalay bay gunshots',
  'mandalay bay incident',
  'mandalay bay shooter',
  'mandalay bay shooters',
  'mandalay bay shooting',
  'mandalay bay shooting video',
  'mandalay bay shootings',
  'mandalay bay suspect',
  'mandalay bay victim',
  'mandalay shooter',
  'mandalay vegas',
  'mandatory evacuation',
  'manslaughter',
  'marcus boyd',
  'marijuana',
  'marilou danley',
  'marion shoot',
  'marjory stoneman douglas',
  'marjory stoneman douglas high school',
  'marshall county',
  'mart mass shooting',
  'martha maccallum',
  'maryland shoot',
  'mass casualty',
  'mass killer',
  'mass shoot',
  'mass shooting',
  'mass shooting california',
  'mass shooting las vegas',
  'mass shooting las vegas 2017',
  'mass shooting mandalay bay',
  'mass shooting route 91',
  'mass shooting vegas',
  'massacre',
  'massillon shooting',
  'massive shooting las vegas',
  'masterbate',
  'masturbation',
  'matt watson',
  'mattwhatitis',
  'mdma',
  'mediation',
  'megyn kelly',
  'meinkampf',
  'mercy hospital shooting',
  'meth',
  'michigan shoot',
  'michigan state case',
  'middle school shooting',
  'mike tyson',
  'milf',
  'milo yiannopoulos',
  'mini 14',
  'minors',
  'missile test',
  'molest',
  'molested',
  'molester',
  'momo',
  'monica morgan',
  'monsanto lawsuit',
  'mosque',
  'mother fucker',
  'motherfucker',
  'ms. pirro',
  'msdhs',
  'msu counselor',
  'msu scandal',
  'muderers',
  'mugging',
  'multiple deaths',
  'multiple officers killed',
  'murder',
  'murdered',
  'murderer',
  'murdering',
  'murders',
  'mushroom stamp',
  'mystikal',
  'naked',
  'nasim',
  'nasim najafi aghdam',
  'national rifle association',
  'national rifle association membership',
  'national thowheeth jamaath',
  'nazi',
  'nazi germany',
  'nazi symbol',
  'nazis',
  'nazism',
  'necrophilia',
  'necrophiliac',
  'negombo',
  'neo nazi',
  'neo nazis',
  'new york new york casino shooting',
  'new york terrorism',
  'new york terrorist',
  'new zealand',
  'new zealand christchurch',
  'new zealand mosque',
  'newspaper shoot',
  'newspaper shooting',
  'newsroom shooting',
  'newzeland',
  'newziland',
  'nice attack',
  'nice terror',
  'nigga',
  'nigger',
  'nigger love',
  'niggr',
  'nightclub massacre',
  'nightclub shooting',
  'nightclub victims',
  'nikolas cruz',
  'nip slip',
  'nipple',
  'nipslip',
  'nkt',
  'no spin zone',
  'noose',
  'norcal shoot',
  'norcal shot',
  'north korea',
  'north korea missile crisis',
  'north korea missile targets',
  'north korea missile test',
  'north korea nuclear',
  'north korea test',
  'nosecandy',
  'nra',
  'nra affiliation',
  'nra convention',
  'nra family',
  'nra lifetime membership',
  'nra membership',
  'nra membership discounts',
  'nra membership levels',
  'nra publications',
  'nra shooting',
  'nra shooting illustrated',
  'nra store',
  'nra website',
  'nsfw',
  'ntk',
  'nude',
  'nudey',
  'nudity',
  'number recall vin',
  'nxivm',
  "o'reilly",
  'obama bomb',
  'obama package',
  'obscene',
  'obscenity',
  'officer shot',
  'omar mateen',
  'oreilly',
  'oreilly factor',
  'orgasm',
  'orgies',
  'orgy',
  'orlando gun control',
  'orlando gunman',
  'orlando mass shooting',
  'orlando massacre',
  'orlando mateen',
  'orlando shooting',
  'orlando victims',
  'out patient',
  'owi',
  'packet crohns',
  'packet intestine',
  'packet stomach',
  'paddock',
  'panties',
  'paralyzed',
  'paris fire',
  'parkland',
  'parkland shoot',
  'parkland shooting',
  'parliament attack',
  'parliament shooting',
  'parsons attack',
  'parsons incident',
  'pasadena mudslide',
  'passenger jet crashes',
  'patent lawsuit',
  'patrick crusius',
  'paul reubens',
  'paula poundstone',
  'pedestrian hit',
  'pediophile',
  'pedophile',
  'pedophiles',
  'pedophilia',
  'pedophilia ring',
  'penis',
  'penises',
  'people shot',
  'perv',
  'pervert',
  'pewdiepie',
  'philando castile',
  'philando castile death',
  'picketing',
  'piff',
  'pipe bomb',
  'piss',
  'pittsburgh shoot',
  'place kleber dead',
  'place kleber injured',
  'place kleber shoot',
  'plane erupts',
  'playboy',
  'pocket rocket',
  'police pursuit',
  'police shoot',
  'police shooting',
  'polk county texas',
  'pollutant',
  'pollution',
  'ponzi scheme',
  'poop shoot party',
  'poor crash test',
  'poor rating',
  'poor score',
  'porno',
  'pornographic',
  'pornography',
  'pothead',
  'prick',
  'priest',
  'priests',
  'prince andrew',
  'prostitute',
  'pubes',
  'pubic',
  'pulse nightclub',
  'punetang',
  'purple mushroom',
  'pussay',
  'pussy',
  'rachel maddow',
  'racism',
  'racist',
  'racist rhetoric',
  'ramblas attack',
  'ramblas hostage',
  'ramming incident',
  'rape',
  'raped',
  'rapid fire barrage',
  'raping',
  'rapist',
  'rated as poor',
  'raunchy',
  'rawdog',
  'rectum',
  'register sex offender',
  'register sex offenders',
  'rehabilitation',
  'remy gonzales',
  'retard',
  'retarded',
  'reverse cowgirl',
  'richard spencer',
  'rick & morty',
  'rifle',
  'rimjob',
  'road head',
  'robbed',
  'robberies',
  'robbery',
  'robbing',
  'robert bowers',
  'rocket man',
  'roger b. taney',
  'rollover',
  'roman polanski',
  'ron helus',
  'roundup breakfast',
  'roundup cereal',
  'roundup killer',
  'roundup lawsuit',
  'route 91',
  'route 91 active shooter',
  'route 91 attack',
  'route 91 concert shooting',
  'route 91 harvest festival shooting',
  'route 91 harvest shooting',
  'route91harvest',
  'rusty trombone',
  's and m',
  'sabotage',
  'sachet crohns',
  'sachet gut',
  'sachet perforate',
  'sachet perforating',
  'sachet pierce',
  'sadist',
  'sadistic',
  'saipov',
  'salaried laid off',
  'san bruno shoot',
  'sandy hook',
  'sandyhook',
  'santa fe high',
  'santa fe high school',
  'santa fe school',
  'santa fe school shooter',
  'santa fe shooting',
  'satanism',
  'sayfullo',
  'scandal',
  'school shoot',
  'school shooting',
  'school shot',
  'score poorly',
  'sean hannity',
  'semen',
  'semi automatic ban',
  'semi automatic rifle',
  'settlement',
  'sex abuse',
  'sex abuse claims',
  'sex abuse victim',
  'sex abuse victims',
  'sex abuser',
  'sex abusers',
  'sex addict',
  'sex crime',
  'sex crime case',
  'sex crime cases',
  'sex cult',
  'sex offender',
  'sex pants',
  'sex slave',
  'sex slavery',
  'sex tape',
  'sex toy',
  'sexiest',
  'sexpot',
  'sextape',
  'sexual',
  'sexual abuse',
  'sexual abuse claim',
  'sexual abuse claims',
  'sexual abuse file',
  'sexual abuse files',
  'sexual abuse settlement',
  'sexual abuse settlements',
  'sexual advance',
  'sexual assault',
  'sexual exploitation',
  'sexual misconduct',
  'sexual slavery',
  'sexually abused',
  'sexually abusing',
  'sexually abusing kids',
  'sexually suggestive',
  'sexy',
  'seyfarth shaw law firm',
  'shahin gheiybe',
  'shane sparks',
  'shayrat air base',
  'sheisty',
  'shit',
  'shitbrick',
  'shitty',
  'shomari legghett',
  'shoot',
  'shoot santa fe',
  'shoot texas',
  'shooter',
  'shooter las vegas strip',
  'shooting',
  'shooting at las vegas',
  'shooting california',
  'shooting california bar',
  'shooting in california',
  'shooting in las vegas',
  'shooting in las vegas 2017',
  'shooting in las vegas last night',
  'shooting in las vegas news',
  'shooting in vegas right now',
  'shooting last night',
  'shooting on the strip',
  'shooting rampage',
  'shooting sports usa',
  'shootings in vegas today',
  'shootout',
  'shot',
  'shot dead',
  'shot fired',
  'shots fired dallas',
  'shots fired las vegas',
  'shrooms',
  'sixty nine',
  'skeet',
  'skinhead',
  'slavery',
  'slore',
  'slut',
  'snipers shoot',
  'soft core porn',
  'somahawk cruise missiles',
  'sorostitute',
  'spain attack',
  'spain hostage',
  'spain terror',
  'speaking clearly',
  'special k',
  'spliff',
  'splooge',
  'squirrel hill',
  'squirrel hill shooting',
  'sri lankas civil war',
  'ssusa',
  'st marys shoot',
  'st. sebastian church',
  'state of emergency',
  'stephen craig paddock',
  'stephen paddock',
  'steve paddock',
  'steven paddock',
  'stiviano',
  'stoned',
  'stoneman shoot',
  'stoner',
  'strasbourg dead',
  'strasbourg injured',
  'strasbourg shoot',
  'strip shooting',
  'striptease',
  'stuart hall',
  'stuck cruise control',
  'student shoot',
  'subway attack',
  'subway incident',
  'suicidal',
  'suicide',
  'suicide bombing',
  'suicides',
  'super drunk',
  'suspect santa fe shooting',
  'suspicious package',
  'sutherland springs',
  'sutherland springs shoot',
  'sutherland springs shot',
  'swastika',
  'swat units',
  'sweatermeat',
  'sweet sixteen pool party',
  'sword',
  'synagogue shoot',
  'syria attack',
  'syrian air force',
  'syrian airbase',
  'syrian attack',
  'syrian warplanes',
  'tailgate defect',
  'tailgate recall',
  'tailgate recall ram',
  'taliban',
  'tampon',
  'tard',
  'tax evasion',
  'tehama shoot',
  'tehama shot',
  'terror',
  'terror attack',
  'terrorism',
  'terrorist',
  'terrorist attack in vegas',
  'terrorist attack vegas',
  'terrorist manhattan',
  'terrorists',
  'testicles',
  'texas attack',
  'texas bomb',
  'texas church massacre',
  'texas church shooting',
  'texas church shooting video',
  'texas deadly shooting',
  'texas explosion',
  'texas high school shooting',
  'texas mass shooting',
  'texas package',
  'texas school shooting',
  'texas shoot',
  'texas shooting',
  'texas shot',
  'thc',
  'the houdini',
  'the nra',
  'the strip las vegas',
  'the weekly standard',
  'third reich',
  'thomas stonewall jackson',
  'thompson center shooting',
  'thong',
  'thousand oaks bar',
  'thousand oaks california',
  'thousand oaks shoot',
  'tit',
  'tits',
  'titty',
  'titty fuck',
  'toke',
  'toking',
  'tongue punch your fartbox',
  'topless',
  'toronto attack',
  'toronto pedestrian van',
  'toronto tragedy',
  'toronto van attack',
  'toronto van hit',
  'toronto victims',
  'torrentz',
  'totaled vehicle',
  'tourist attack',
  'tournament shoot',
  'tragedy in vegas',
  'train crash',
  'train dangling',
  'train derail',
  'train fatalities',
  'train fatality',
  'train injuries',
  'tramp',
  'tramp stamp',
  'tranny',
  'traphouse',
  'trauma',
  'tree of life shoot',
  'tree of life synagogue',
  'truck attack',
  'truck hits',
  'truck terror',
  'truck terrorist',
  'trump doral shooting',
  'trump hotel gunfight',
  'trump syria attack',
  'tube attack',
  'tube incident',
  'tucker',
  'tucker carlson',
  'tucker carlson tonight',
  'turd',
  'twat',
  'tyreek hill',
  'uncontrollable cruise control',
  'underage sex',
  'unifor',
  'university shoot',
  'uppers',
  'upskirt',
  'us air strikes in syria',
  'us missile attack',
  'uzi',
  'va jay jay',
  'vagina',
  'vagine',
  'vahjayjay',
  'van attack',
  'van hits crowd',
  'van hits people',
  'van hits tourists',
  'van plough crowd',
  'van strikes crowd',
  'van terror',
  'vaporizer',
  'vegas attack',
  'vegas concert shooting',
  'vegas gunman',
  'vegas gunshots',
  'vegas incident today',
  'vegas news live',
  'vegas right now',
  'vegas shooter',
  'vegas shooter caught',
  'vegas shooters',
  'vegas shooting',
  'vegas shooting news',
  'vegas shooting now',
  'vegas strip shooting today',
  'vegas suspect',
  'vegas victim',
  'vehicle hits people in barcelona',
  'ventura shoot',
  'vibrator',
  'victim',
  'victims',
  'victor salva',
  'vincent margera',
  'virginia counterprotests',
  'vixen',
  'wal mart mass',
  'wal mart shooting',
  'walmart mass shooting',
  'walmart shooting',
  'wanker',
  'war crime',
  'wardobe malfunction',
  'weapon',
  'weapons',
  'weed',
  'wench',
  'westminster attack',
  'westminster shooting',
  'whipits',
  'white nationalist',
  'white nationalists',
  'white supremacist',
  'white supremacists',
  'white supremacy',
  'whitney cummings',
  'whore',
  'whores',
  'will hayden',
  'xxx',
  'yelchin',
  'youtube attacker',
  'youtube headquarters',
  'youtube hq',
  'youtube shoot',
  'zooted',
];
